global = typeof global !== 'undefined' ? global : window;

const supplant = function (string, properties) {
    return string.replace(/{([^{}]*)}/g, function (a, b) {
        var r = properties[b];
        return typeof r === 'string' || typeof r === 'number' ? r : a;
    });
};

const inflector = (number, one, two, five) => {
    number = Math.abs(number);
    number %= 100;

    if (number >= 5 && number <= 20) {
        return five;
    }

    number %= 10;

    if (number === 1) {
        return one;
    }

    if (number >= 2 && number <= 4) {
        return two;
    }

    return five;
};

const parseOptions = (string, value) => {
    const options = {};

    string.replace(/(\w+)\s*\{([\wа-яёіїє\s#]+)\}/g, function (match, option, content) {
        options[option] = content;
        return match;
    });

    // Replace number placeholder
    return inflector(value, options.one, options.few, options.many).replace('#', value);
};

const intlSupplant = (string, properties) => {
    if (!/\{.+,.+\}/g.test(string)) {
        // No intl string found
        return supplant(string, properties);
    }

    return supplant(
        string.replace(/{(\w+),\s*(\w+),\s*([\wа-яёіїє\s{#}]+)\}/gi, function (match, property, mode, options) {
            return parseOptions(options, properties[property]);
        }),
        properties
    );
};

class L10n {
    constructor() {
        this.translations = null;
        this.locale = typeof window !== 'undefined' ? window.LOCALE : context.appContext.config.locale;
    }

    trans(phrase, values) {
        let message = global.MESSAGES[this.locale];

        if (!message) {
            Sentry.captureMessage('No locale found `' + this.locale + '`');
            return '';
        }

        for (let i = 0, path = phrase.split('.'), len = path.length; i < len; i++) {
            message = message[path[i]] || [];
        }

        try {
            return intlSupplant(message, values);
        } catch (e) {
            Sentry.captureMessage('Problem with phrase `' + phrase + '` on locale `' + this.locale + '`');
            return '';
        }
    }
}

const Translations = new L10n();
const trans = Translations.trans.bind(Translations);

if (typeof window !== 'undefined') {
    window.trans = trans;
}

export {trans};
